import momentTz from 'moment-timezone';
import { TimezoneDetail } from 'common/models';

export const getSessionStartDateTime = (date: Date, time: string, timezone: string) => {
    const hours = Number.parseInt(time.split(':')[0]);
    const mins = Number.parseInt(time.split(':')[1]);
    const millis = date.getMilliseconds().toString().padStart(3, '0');
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate();
    const dateString = `${year}-${month}-${day} ${hours}:${mins}:${millis}`;
    const zoneOffsetDate = momentTz.tz(dateString, 'YYYY-MM-DD HH:mm:SSSS', timezone);

    return zoneOffsetDate.toISOString();
};

export const getSessionEndDateTime = (date: Date, time: string, timezone: string) => {
    const hours = Number.parseInt(time.split(':')[0]);
    const mins = Number.parseInt(time.split(':')[1]);
    date.setHours(hours);
    date.setMinutes(mins);
    date.setSeconds(0);
    date.setMilliseconds(0);
    const millis = date.getMilliseconds().toString().padStart(3, '0');
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate();
    const dateString = `${year}-${month}-${day} ${hours}:${mins}:${millis}`;
    const zoneOffsetDate = momentTz.tz(dateString, 'YYYY-MM-DD HH:mm:SSSS', timezone);

    return zoneOffsetDate.toISOString();
};

export const getDefaultStartTime = () => {
    const now = new Date();
    now.setMinutes(Math.ceil(now.getMinutes() / 30) * 30);
    const hours = now.getHours().toString().padStart(2, '0');
    const mins = now.getMinutes().toString().padStart(2, '0');
    return `${hours}:${mins}`;
};

export const getDefaultEndTime = () => {
    const now = new Date();
    now.setMinutes((Math.ceil(now.getMinutes() / 30) + 2) * 30);
    const hours = now.getHours().toString().padStart(2, '0');
    const mins = now.getMinutes().toString().padStart(2, '0');
    return `${hours}:${mins}`;
};

export const getUserTimezone = (timezoneList: Array<TimezoneDetail>) => {
    const offset = momentTz.tz(momentTz.tz.guess()).format('Z');
    const zone = timezoneList.find((item: TimezoneDetail) => item.offset === offset);
    return zone ? zone.tzCode : '';
};

export const getTimeList = () =>
    Array.from(
        {
            length: 48
        },
        (_, hour) =>
            momentTz({
                hour: Math.floor(hour / 2),
                minutes: hour % 2 === 0 ? 0 : 30
            }).format('HH:mm')
    );

export const convertIsoToTimeField = (dateValue: string, timezone: string) => {
    if (dateValue.charAt(dateValue.length - 1) !== 'Z') {
        dateValue += 'Z';
    }
    const zoneOffsetDate = momentTz.tz(dateValue, 'YYYY-MM-DDTHH:mm:SSSZ', timezone);
    const hours = zoneOffsetDate.hours().toString().padStart(2, '0');
    const mins = zoneOffsetDate.minutes().toString().padStart(2, '0');
    return `${hours}:${mins}`;
};

export const convertIsoToDate = (dateValue: string) => {
    if (dateValue.charAt(dateValue.length - 1) !== 'Z') {
        dateValue += 'Z';
    }
    return new Date(dateValue);
};

export const getGroupedTimezones = () => {
    const allTimezones: Array<string> = momentTz.tz.names();
    const groupedTimezones: Array<TimezoneDetail> = [];

    for (const index in allTimezones) {
        const offset = momentTz.tz(allTimezones[index]).format('Z');
        const labelSplit = allTimezones[index].split('/');
        const label = labelSplit[labelSplit.length - 1];

        let offsetIndex = groupedTimezones.findIndex(
            (item: TimezoneDetail) => item.offset === offset
        );
        if (offsetIndex === -1) {
            offsetIndex = groupedTimezones.length;
            groupedTimezones.push({
                tz: [],
                label: '',
                offset,
                tzCode: ''
            });
        }

        groupedTimezones[offsetIndex].tz.push(label);
        groupedTimezones[offsetIndex].tzCode = allTimezones[index];

        // sort by offset - to +
        groupedTimezones.sort((a, b) => {
            const aSign = a.offset.charAt(0) === '+' ? 1 : -1;
            const aTime = a.offset.slice(1);
            const [aH, aM] = aTime.split(':');
            const bSign = b.offset.charAt(0) === '+' ? 1 : -1;
            const bTime = b.offset.slice(1);
            const [bH, bM] = bTime.split(':');
            return (
                aSign * (Number.parseInt(aH) * 60 + Number.parseInt(aM)) -
                bSign * (Number.parseInt(bH) * 60 + Number.parseInt(bM))
            );
        });
    }

    return groupedTimezones;
};

export const calculateEndTime = (startTime: string) => {
    const hours = Number.parseInt(startTime.split(':')[0]);
    const mins = Number.parseInt(startTime.split(':')[1]);
    const now = new Date();
    now.setHours(hours);
    now.setMinutes(mins + 60);
    const newHours = now.getHours().toString().padStart(2, '0');
    const newMins = now.getMinutes().toString().padStart(2, '0');
    return `${newHours}:${newMins}`;
};

export const removeTimeOffset = (value: Date | string) => {
    const date = new Date(value);
    date.setTime(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
    return date.toISOString();
};
